const mutations = {
  'SET_USER' (state, { user }) {
    localStorage.removeItem('user')
    if (user) {
      state.user = user.user
    } else {
      state.user = null
    }
    localStorage.setItem('user', JSON.stringify(user))
  },
  'SET_PERMISSIONS' (state, permissions) {
    state.permissions = permissions
  }
}

export default mutations
